import React from 'react';
import clsx from 'clsx';
import { hasErrorCode } from '@/utils/errors';
import errorCodes from '@/constants/errors';
import NotAuthorised from '@/components/errors/NotAuthorised';
import { fetchUsers, toggleUserSelected, toggleUsersPresentation } from '../actions';

const UsersPanelContainer = ({
  readErrors,
  canRead,
  className,
  children,
}) => {
  if (!canRead || hasErrorCode(readErrors, errorCodes.forbidden)) {
    return <NotAuthorised />;
  }

  return (
    <div className={clsx('aridhia-users-panel-container', className)}>
      { children }
    </div>
  );
};

export const mapStateToProps = ({
  auth: { role: { permissions }, users },
}, { category, displayAs }) => {
  const item = users[category];
  return {
    allowRoleLink: permissions.roles.read,
    canRead: permissions.users.read,
    currentPage: item.currentPage,
    display: displayAs || item.display,
    pageCount: item.totalPages,
    pageSize: item.pageSize,
    readErrors: item.readErrors,
    readStatus: item.readStatus,
    total: item.count,
    users: item.results,
  };
};

export const mapDispatchToProps = {
  fetchData: fetchUsers,
  onCheckBoxClick: toggleUserSelected,
  togglePresentation: toggleUsersPresentation,
};

export default UsersPanelContainer;
